import { styled } from '@mui/system';
import Box from '@mui/material/Box';

export const SpinnerContainer = styled(Box)(() => ({}));
